import { isBefore, isWithinInterval, isAfter, startOfDay, endOfDay, isSameDay } from 'date-fns';

import { TValidator } from './types';

export const withinRange =
  (minDateInput?: Date | string, maxDateInput?: Date | string): TValidator =>
  (dateInput: Date | string) => {
    if (!minDateInput && !maxDateInput) {
      throw Error('At least one date is required.');
    }

    const value = new Date(dateInput);

    if (minDateInput && maxDateInput) {
      const minDate = new Date(minDateInput);
      const maxDate = new Date(maxDateInput);

      if (minDate <= maxDate) {
        return isWithinInterval(value, { start: startOfDay(minDate), end: endOfDay(maxDate) })
          ? undefined
          : 'Given date is not within range';
      }

      return 'Inconsistent date range given';
    }

    if (minDateInput) {
      const minDate = new Date(minDateInput);

      return isSameDay(value, minDate) || isAfter(value, startOfDay(minDate))
        ? undefined
        : 'Given date is before the minimal date';
    }

    if (maxDateInput) {
      const maxDate = new Date(maxDateInput);

      return isSameDay(value, maxDate) || isBefore(value, endOfDay(maxDate))
        ? undefined
        : 'Given date is after maximal date';
    }

    return undefined;
  };
